import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import PageHero from '../components/PageHero';
import { BgImage, Img } from '../components/Img';
import { IMG } from '../images';

// Real photos of ProClimb work. Labels come from src/images.js (only specific job types that are visible/confirmed).
const gallery = [IMG.lift, IMG.wavy, IMG.glassroof, IMG.grinding, IMG.bucket, IMG.wash, IMG.tower, IMG.glasswork, IMG.ledge, IMG.darkfacade, IMG.whitefacade, IMG.cityview, IMG.pole, IMG.team].map((image) => ({ image, tag: image.tag, alt: image.alt }));

const stats = [
  { n: '10+', label: 'Years Experience' },
  { n: '300+', label: 'Projects Completed' },
  { n: '100%', label: 'Safety Record' },
  { n: '24/7', label: 'Emergency Response' },
];

const Projects = () => (
  <div>
    <PageHero
      image={IMG.facade}
      position="50% 40%"
      title="Our Projects & Gallery"
      subtitle="Showcasing our rope access expertise across NSW"
      minHeight="52vh"
    />

    <section className="section">
      <div className="container">
        <div className="section-header reveal">
          <span className="eyebrow">Our work</span>
          <h2>Real Jobs. Real Conditions.</h2>
          <p>
            A selection of photos from our own rope access work across Sydney and NSW: high-rise window cleaning, façade
            maintenance, glazing, height safety and emergency interventions.
          </p>
        </div>
        <div className="gallery">
          {gallery.map((g) => (
            <figure key={g.alt} className="gallery-item reveal">
              <Img image={g.image} alt={g.alt} sizes="(max-width: 768px) 50vw, (max-width: 1200px) 33vw, 420px" />
              <figcaption><span className="gallery-tag">{g.tag}</span></figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>

    <section className="section bg-light">
      <div className="container">
        <div className="callout reveal">
          <h3>References &amp; Case Studies</h3>
          <p>
            Looking for detailed case studies or client references for a specific type of work? We are happy to provide them on
            request.
          </p>
          <Link to="/contact#quote-form" className="btn-primary">Request Case Studies <ArrowRight size={18} aria-hidden="true" /></Link>
        </div>
      </div>
    </section>

    <section className="stats-strip" aria-label="ProClimb Solutions at a glance">
      <div className="stats-grid">
        {stats.map((s, i) => (
          <div key={s.label} className={`stat reveal d${i % 4}`}>
            <div className="stat-number">{s.n}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </section>

    <section className="final-cta">
      <BgImage image={IMG.hero} />
      <h2>Ready to Start Your Project?</h2>
      <p style={{ fontSize: '1.2rem', maxWidth: '700px', margin: '0 auto 2rem' }}>
        Contact us for a free consultation and quote
      </p>
      <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link to="/contact#quote-form" className="btn-primary">Get a Quote</Link>
        <a href="tel:0426920301" className="btn-secondary"><Phone size={18} aria-hidden="true" /> Call: 0426 920 301</a>
      </div>
    </section>
  </div>
);

export default Projects;
